import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsParcelsService} from '../../../services/settings-parcels.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss']
})
export class NotificationModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    agreementText = '';
    subject = '';
    originalMessage = '';
    originalSubject = '';
    emailTemplate = null;
    placeholders = [
        '[[BUILDING_ADDRESS]]',
        '[[BUILDING_NAME]]',
        '[[UNIT_NUMBER]]',
        '[[RESIDENT_NAME]]',
        '[[RESIDENT_EMAIL]]',
        '[[DIRECTION]]',
        '[[RECEIVED_AT]]',
        '[[RECEIVED_BY]]',
        '[[PARCEL_TYPE]]',
        '[[NUMBER_OF_PIECES]]',
        '[[BAR_CODE]]',
        '[[DESCRIPTION]]',
        '[[EMAIL_TO_RESIDENT]]',
        '[[STATUS]]',
        '[[SIGNATURE]]',
        '[[PICKED_UP_AT]]',
        '[[PICKED_UP_BY]]',
        '[[MY_SIGNATURE]]',
        '[[PARCEL_ID]]',
        '[[COURIER]]',
        '[[INVITATION_LINK]]'
    ];
    emailTemplates = [];
    showSpinner = false;

    constructor(
        public api: ApiClientService,
        public settingsParcelsService: SettingsParcelsService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.getEmailTemplates(this.settingsParcelsService.notificationModalStaffOrResident);
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if(this.settingsParcelsService.selectedItemData[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings']) {
            this.settingsParcelsService.selectedItemData[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'].forEach((setting) => {
                if(setting.action == (this.settingsParcelsService.notificationModalNotificationType != 'pickedUp' ? this.settingsParcelsService.notificationModalNotificationType : 'picked_up')) {
                    if(!setting.emailTemplateOtherSubject && !setting.emailTemplateOtherMessage) {
                        this.emailTemplate = setting.emailTemplate;
                        this.emailTemplates.forEach((template) => {
                            if (template.id == this.emailTemplate) {
                                this.subject = template.subject;
                                this.agreementText = template.message;
                                this.originalMessage = template.message;
                                this.originalSubject = template.subject;
                            }
                        });
                    } else {
                        this.emailTemplate = 0;
                        this.subject = setting.emailTemplateOtherSubject;
                        this.agreementText = setting.emailTemplateOtherMessage;
                        this.originalMessage = setting.emailTemplateOtherMessage;
                        this.originalSubject = setting.emailTemplateOtherSubject;
                    }
                }
            });
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsParcelsService.isNotificationModalShow = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsParcelsService.isNotificationModalShow = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.emailTemplate && form.value.emailTemplate !== 0) toastr.warning('Email template should not be blank.');
            if (!form.value.subject) toastr.warning('Email subject should not be blank.');
            return;
        }
        if(!this.agreementText) {
            toastr.warning('Email text should not be blank.');
            return;
        }
        const emailTemplate = form.value.emailTemplate;
        const formattedAction = this.settingsParcelsService.notificationModalNotificationType != 'pickedUp' ? this.settingsParcelsService.notificationModalNotificationType : 'picked_up';

        if (!emailTemplate && emailTemplate !== 0) { toastr.warning('Email template is not set.'); return; }
        let index = -1;
        let data = {[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings']: []};
        if(this.settingsParcelsService.selectedItemData[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings']) {
            this.settingsParcelsService.selectedItemData[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'].filter((setting) => {
                data[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'].push({
                    action: setting.action,
                    emailTemplate: setting.emailTemplate,
                    emailTemplateOtherSubject: setting.emailTemplateOtherSubject ? setting.emailTemplateOtherSubject : undefined,
                    emailTemplateOtherMessage: setting.emailTemplateOtherMessage ? setting.emailTemplateOtherMessage : undefined,
                });
            });
        }
        data[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'].filter((notification, indexInArray) => {
            if(notification.action == formattedAction)
                index = indexInArray;
        });

        if(index != -1) {
            data[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'][index] = {
                action: formattedAction
            };
            if(this.emailTemplate === 0 || this.templateMessageIsModified()) {
                data[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'][index].emailTemplateOtherSubject = this.subject;
                data[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'][index].emailTemplateOtherMessage = this.agreementText;
            } else {
                data[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'][index].emailTemplate = this.emailTemplate;
            }
        } else {
            data[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'].push({
                action: formattedAction,
            });
            if(this.emailTemplate === 0) {
                data[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'].filter((notification) => {
                    if(notification.action == formattedAction) {
                        notification.emailTemplateOtherSubject = this.subject;
                        notification.emailTemplateOtherMessage = this.agreementText;
                    }
                });
            } else {
                data[this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings'].filter((notification) => {
                    if(notification.action == formattedAction) {
                        notification.emailTemplate = this.emailTemplate;
                    }
                });
            }
        }

        this.disabledSubmit = true;
        const url = `/v1/parcel-service-settings/${this.settingsParcelsService.selectedItemData.corporationNumberBd}.json`;
        this.api.patch('domainParcels', url, data).subscribe(
            () => this.updateView('Email template has been updated successfully', data),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Email template has failed to update');
            }
        );
    }

    updateView(msg: string, data): void {
        toastr.success(msg);
        this.updateInfo(data);
        this.form.reset();
        this.hideModal();
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    initSummernote(enabled) {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => {
                    this.agreementText = contents;
                    this.emailTemplate = 0;
                }
            },
            toolbar: enabled ? [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ] : [],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
                this.emailTemplate = 0;
            });
        $('.note-editable').html(this.agreementText).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });

        if(!enabled)
            summernote.summernote('disable');
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote(true), 300);
    }

    emailTemplateSelect(arr: Array<any>) {
        return arr.map(template => ({value: template.id, optionText: template.name}));
    }
    changeTemplate(event): void {
        this.emailTemplate = event;
        if(event == -1) {
            this.agreementText = '';
            document.getElementsByClassName('note-editable panel-body')[0].innerHTML = '';
        } else {
            const templateObject = this.emailTemplates.find( (template) => template.id == event);
            if(templateObject) {
                if(templateObject.id != 0) {
                    this.subject = templateObject.subject;
                    this.agreementText = templateObject.message;
                    document.getElementsByClassName('note-editable panel-body')[0].innerHTML = templateObject.message;
                } else {
                    this.subject = '';
                    this.agreementText = '';
                    document.getElementsByClassName('note-editable panel-body')[0].innerHTML = '';
                }
            }
        }
    }

    public getEmailTemplates(type) {
        this.showSpinner = true;
        const url = `/v1/email_template.json?per-page=1000&type=${type == 'staff' ? 'staff' : 'resident'}`;
        this.api.get('domainParcels', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.emailTemplates = body.entities;
                this.emailTemplates.push({id: 0, name: 'Other'});
                this.initData();
                this.showSpinner = false;
                this.initSummernote(false);
            },
            error => this.api.errorHandler(error, 'Failed get Templates')
        );
    }

    templateMessageIsModified(): boolean {
        let isModified = false;
        let originalTemplateMessage = '';
        this.emailTemplates.forEach( template => {
           if(template.id == this.emailTemplate)
               originalTemplateMessage = template.message.replace(/&nbsp;/g, '').replace(/\s/g, '').replace(/<br>/g, '');
        });
        const messageToSend = this.agreementText.replace(/&nbsp;/g, '').replace(/\s/g, '').replace(/<br>/g, '');
        if(originalTemplateMessage != messageToSend)
            isModified = true;
        return isModified;
    }

    updateInfo(data) {
        const property = this.settingsParcelsService.notificationModalStaffOrResident + 'NotificationSettings';
        this.settingsParcelsService.selectedItemData[property].forEach(setting => {
            data[property].forEach(item => {
                if(setting.action == item.action) {
                    if(item.emailTemplate > 0) {
                        setting.emailTemplate = item.emailTemplate;
                        setting.emailTemplateOtherSubject = null;
                        setting.emailTemplateOtherMessage = null;
                    } else {
                        setting.emailTemplate = null;
                        setting.emailTemplateOtherSubject = item.emailTemplateOtherSubject;
                        setting.emailTemplateOtherMessage = item.emailTemplateOtherMessage;
                    }
                }
            });
        });
    }

    hideEditPanelSetter() {
        this.showEditPanel = false;
        setTimeout( () => this.initSummernote(false), 300);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/notification-modal/notification-modal.component.ts